import React, { Component } from 'react'
import { checkTranslation } from '../utils/useful'

export default class IntractionActionsList2 extends Component {
    state = {

    }

    render() {
        return (
            <button className="flexcb w-100 hover-gray p-2 br-5" onClick={() => this.props?.onClick && this.props?.onClick(this.props.data.key)}>
                <div className='flexc'>
                    {this.props.data.icon ?
                        <img className='flexcc' width={18} src={this.props.data.icon} />
                        :
                        this.props.data.check === true ?
                            <img className='flexcc' width={18} src='/assets/icons/note/check-yellow.svg' />
                            :
                            <div style={{ width: '18px', height: '18px' }}></div>
                    }
                    <div>
                        <p className="font-size-12 mld-3 main-c3 text-start" style={{ width: this.props.data.shortcut ? '120px' : '185px', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{checkTranslation(this.props.data.title)}</p>
                        {this.props.data.des && (
                            <p className="font-size-10 mld-3 main-c7 text-start" style={{ width: this.props.data.shortcut ? '120px' : '185px', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{checkTranslation(this.props.data.des)}</p>
                        )}
                    </div>
                </div>

                <div className='font-size-10 main-c8'>
                    <div>
                        {this.props.data.shortcut ?
                            <p className=' text-start' >{this.props.data.shortcut}</p>
                            :
                            this.props.data.sub == true ?
                                <img className='flexcc rtl-button' width={18} src='/assets/icons/arrow-right-gray.svg' />
                                :
                                this.props.data.check2 == true ?
                                    <img className='flexcc' width={18} src='/assets/icons/note/check-yellow.svg' />
                                    :
                                    <div style={{ width: '18px', height: '18px' }}></div>
                        }
                    </div>
                </div>
            </button>
        )
    }
}
